import { Component, EventEmitter, Output } from '@angular/core';
import { LoginAction } from './login-action.model';

@Component({
  selector: 'app-login-card',
  templateUrl: './login-card.component.html',
  styleUrls: ['./login-card.component.scss'],
})
export class LoginCardComponent {
  @Output()
  logedIn = new EventEmitter<LoginAction>();

  username = '';
  password = '';
  showPassword = false;

  constructor() {}

  login(): void {
    const action: LoginAction = {
      username: this.username,
      password: this.password,
    };
    this.logedIn.emit(action);
    this.username = '';
    this.password = '';
  }
}
